import { useTranslation } from "react-i18next"

import { Info } from "@/components/icons"
import { cn } from "@/lib/utils"

import {
  renderedPreviewBannerClassName,
  renderedPreviewBannerIconClassName,
} from "./rendered-preview-banner-classes"

type RenderedPreviewBannerProps = {
  className?: string
  kind?: "rendered" | "extracted"
}

/**
 * Shown when the in-app preview may differ from the downloadable source (e.g. indexed/converted
 * body or approximate viewer types). Controlled by citation preview shell — not per-viewer highlight quality.
 */
export function RenderedPreviewBanner({
  className,
  kind = "rendered",
}: RenderedPreviewBannerProps) {
  const { t } = useTranslation()
  const message =
    kind === "extracted"
      ? t("analysispanel.extracted_text_preview_banner", {
          defaultValue:
            "This preview contains text extracted from the cited file. Download the original when Prism has retained or can still access it.",
        })
      : t("analysispanel.rendered_preview_banner", {
          defaultValue: "This view is a rendered copy. Download it to view the original.",
        })
  return (
    <div className={cn(renderedPreviewBannerClassName, className)} role="status">
      <Info aria-hidden className={renderedPreviewBannerIconClassName} />
      <p className="min-w-0">{message}</p>
    </div>
  )
}
